import { observer } from 'mobx-react-lite'
import React, { useContext } from 'react'
import { CampaignContext } from '../../../../../../contexts/CampaignContext'
import InfluencerColumn from './InfluencerColumn'

export default observer(function InfluencerColumns() {
  const { campaign } = useContext(CampaignContext)

  return (
    <div className="border-1 dark:border-rb-dark-mode-lighter rounded-md p-4 mt-4">
      <p className="text-sm font-bold mb-4 dark:text-white">Influencers</p>
      <div className="flex flex-wrap gap-4">
        {campaign.statuses.map(status => <InfluencerColumn key={status.id} status={status}/>)}
      </div>
    </div>
  )
})